import { useEffect } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import { selectIpRestrictedStatus } from 'slices/ipRestrictedSlice'

export const useIpRestrictedRedirect = () => {
  const { show } = useSelector(selectIpRestrictedStatus, shallowEqual)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (show && pathname !== '/ip-restricted') {
      navigate('/ip-restricted')
    }
  }, [show, navigate, pathname])
}
